// extracted by mini-css-extract-plugin
export default {"leyenda":"leyendas_leyenda__ie+bA"};